import { GuardianLogo } from '@components'
import { paths, useLoginQry } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import { Button, ErrorDisplay, Input } from 'mmfintech-portal-commons'
import type React from 'react'
import { Link } from 'react-router-dom'
import './Login.scss'

function Login() {
  const { formValues, login, loginError, loginFetching, resetLogin } = useLoginQry()

  async function handleSubmit(e: React.BaseSyntheticEvent) {
    e.preventDefault()
    void login()
  }

  return (
    <div className='login-wrapper'>
      <div className='login-container'>
        <GuardianLogo />

        <div className='login-content-wrapper'>
          <div className='login-content'>
            <div className='heading'>{tr('PORTAL.LOGIN.TITLE', 'Sign in')}</div>

            <form className='login-form' noValidate onSubmit={handleSubmit}>
              <Input
                id='email'
                type='email'
                data-test='email'
                label={tr('PORTAL.LOGIN.EMAIL', 'Email')}
                {...formValues.registerInput('email', resetLogin)}
                disabled={loginFetching}
                hideErrorLine
                hideRequired
                autoFocus
              />

              <Input
                id='password'
                type='password'
                data-test='password'
                label={tr('PORTAL.LOGIN.PASSWORD', 'Password')}
                {...formValues.registerInput('password', resetLogin)}
                disabled={loginFetching}
                autoComplete='off'
                hideErrorLine
                hideRequired
              />

              <div className='link-wrap' data-test='forgot-password'>
                <Link to={paths.forgotPassword()}>{tr('PORTAL.LOGIN.FORGOT_PASSWORD', 'Forgot password?')}</Link>
              </div>

              <ErrorDisplay error={loginError} />

              <Button
                type='submit'
                color='alternative'
                text={tr('PORTAL.LOGIN.LOGIN_BUTTON', 'Log in')}
                loading={loginFetching}
                data-test='button-submit'
              />
            </form>
          </div>

          <div className='signup-link-wrapper'>
            {tr('PORTAL.LOGIN.NO_ACCOUNT', "Don't have an account?")}{' '}
            <Link to={paths.signUp()} data-test='sign-up'>
              <span>{tr('PORTAL.LOGIN.SIGNUP_BUTTON', 'Sign up')} →</span>
            </Link>
          </div>
        </div>

        <span />
      </div>
    </div>
  )
}

export default Login
